import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

export default makeStyles((theme) => ({
  root: {
    height: 'calc(100vh - 215px)',
  },
  header: {
    borderBottom: '2px solid #eee',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    // height: 'calc(100vh - 120px)',
    borderRadius: 4,
    // boxShadow: 'none',
  },
  messagesContainerEmail: {
    borderBottom: '1px solid #eee',
    overflowY: 'auto',
    height: 'calc(100vh - 355px)',
  },
  messagesContainerSms: {
    borderBottom: '1px solid #eee',
    overflowY: 'auto',
    height: 'calc(100vh - 255px)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  threadsContainer: {
    overflowY: 'auto',
    height: 'calc(100vh - 220px)',
  },
  avatarGroup: {
    marginLeft: theme.spacing(1.5)
  },
  textCenter: {
    textAlign: 'center'
  },
  link: {
    'color': 'inherit',
    'a&:visited': {
      color: 'inherit',
    },
  },
  composerContainer: {
    borderLeft: '1px solid #dfdfdf',
    borderRight: '1px solid #dfdfdf',
    borderBottom: '1px solid #dfdfdf',
    boxShadow: '0px -5px 10px #afafaf1f'
  }
}));
